import React from 'react';
import PropTypes from 'prop-types';

export default function ContactList({ title, titlePlural, items, children }) {
  // Filter the items to remove falsy values (null, undefined, empty
  // strings, etc.) and remove duplicates case-insensitively
  const validItems = [];
  items.forEach((item) => {
    if (!item) {
      return;
    }

    const downcase = item.toLowerCase().trim();
    if (validItems.indexOf(downcase) >= 0) {
      return;
    }

    validItems.push(downcase);
  });

  if (validItems.length === 0) {
    return null;
  }

  return (
    <>
      <h2 className='mb-7 text-2xl font-semibold'>
        {validItems.length > 1 ? titlePlural : title}
      </h2>
      <ul className='list-none p-0'>
        {validItems.map((item) => (
          <li className='m-0' key={item}>
            {children(item)}
          </li>
        ))}
      </ul>
    </>
  );
}

ContactList.propTypes = {
  title: PropTypes.string.isRequired,
  titlePlural: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.func.isRequired,
};
